import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { LetterDeliveryMethod, PageOrientation } from '@app/modules/letters/models/letters.model';
import { LettersService } from '@app/modules/letters/services/letters.service';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { from, Observable } from 'rxjs';

@Component({
  selector: 'app-letter-delivery-methods-dropdown',
  templateUrl: './letter-delivery-methods-dropdown.component.html',
  styleUrls: ['./letter-delivery-methods-dropdown.component.scss']
})
export class LetterDeliveryMethodsDropdownComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;
  isLoading: boolean;
  user$: any;
  filterString: string;
  options: Observable<PagedData<LetterDeliveryMethod>>;

  constructor(
    private lettersService: LettersService,
  ) { }

  ngOnInit(): void {
    this.options = from(this.lettersService.getLetterDeliveryMethods(100, 0, "sortOrder-asc", `(enabled = "true")`))
  }
}
